import React, { useState, useEffect, useRef } from 'react';
import {
    SelectContainerV2,
    Label,
    Arrow,
    Clearabled,
    Plus,
    Legenda,
    Options,
    Option,
    OptionLabel,
    OptionCommonNames,
    OptionScientificName,
    OptionLabelBlock,
    OptionDescription,
    NoOptions,
    YesNoContainer,
    YesNoContainerMobile,
    Loading
} from './styles';
import ArrowIcon from "../../assets/icons/icon-arrow.svg";
import DeleteIcon from "../../assets/icons/icon-close-without-circle-gray.png";
import Interruptor from '../../components/interruptor';
import ModalAlert from '../../components/modal/modalGeneric';
import Button from '../../components/button/button_v2';
import ButtonAddNew from '../buttonAddNew';
import Solicitar from '../../pages/solicitar';
import { store } from "react-notifications-component";
import IconHelp from '../../assets/icons/help';

import ArrowDown from '../../assets/icons/icons8-expand-arrow-32.png';
import { TaglineM } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';
import { filterAndRankOptions } from '../../services/textSearch';

export const USER = "@userinfo";


const SelectV2 = ({ ...props }) => {
    const [ref] = useState(useRef());
    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState('');
    const [selectOptions, setSelectOptions] = useState([]);
    const [yesNoValue, setYesNoValue] = useState(true);

    const [solicitaP, setSolicitaP] = useState(false);
    const [showModalSolicitar, setModalSolicitar] = useState(false);
    const [showModalBlock, setModalBlock] = useState(false);

    const [addOptions, setAddOptions] = useState(false);
    const [limit, setLimit] = useState(20);

    const [isclose, setisclose] = useState(false);

    const triggerOnChange = (nextValue) => {
        if (typeof props.onChange === 'function') {
            props.onChange(nextValue);
        }
    };

    /**
     * A API monta o label como "nomes comuns - nome científico" e envia o
     * nome científico à parte. Quando ele vem separado, recortamos o label pelo
     * sufixo exato; senão caímos no último " - " (cache antigo do filtro).
     */
    const splitOptionLabel = (op) => {
        const label = `${op.label ?? ''}`;
        const scientificName = `${op.nome_cientifico ?? ''}`;

        const separatorIndex = scientificName && label.endsWith(scientificName)
            ? label.lastIndexOf(` - ${scientificName}`)
            : label.lastIndexOf(' - ');

        if (separatorIndex === -1) return null;

        const commonNames = label.slice(0, separatorIndex).trim();
        const scientific = label.slice(separatorIndex + 3).trim();
        if (!commonNames || !scientific) return null;

        return { commonNames, scientificName: scientific };
    };

    const renderOptionLabel = (op) => {
        const parts = props.highlightScientificName ? splitOptionLabel(op) : null;
        if (!parts) return op.label;

        return (
            <OptionLabel>
                <OptionScientificName>{parts.scientificName}</OptionScientificName>
                <OptionCommonNames>{parts.commonNames}</OptionCommonNames>
            </OptionLabel>
        );
    };

    const onChange = (valueOp) => {
        if (value) {
            if (value.value !== valueOp.value) {
                if (props.isSearch === true) {
                    if (valueOp.value != props.value) {
                        triggerOnChange(valueOp);
                        setValue(valueOp);
                        setIsOpen(false);
                    } else {
                        setValue(valueOp);
                    }
                } else {
                    triggerOnChange(valueOp);
                    setValue(valueOp);
                    setIsOpen(false);
                }
            }
        } else {
            if (props.isSearch === true) {
                if (valueOp.value != props.value) {
                    triggerOnChange(valueOp);
                    setValue(valueOp);
                    setIsOpen(false);
                } else {
                    setValue(valueOp);
                }
            } else {
                triggerOnChange(valueOp);
                setValue(valueOp);
                setIsOpen(false);
            }
        }
    }

    const changeInput = (value) => {
        if (props.clearOnEmptyInput && value.target.value === '') {
            setValue('');
            triggerOnChange({ value: '', label: '' });
            setSelectOptions(props.options);
            return;
        }

        const inputText = value.target.value;
        setValue(inputText);

        const filterOptions = filterAndRankOptions(
            props.options,
            inputText,
            (option) => option.searchTerms || [option.label]
        );

        setSelectOptions(filterOptions);
    }

    const close = (e) => {
        setTimeout(() => {
            setisclose(true);
        }, 300);
    }

    const getOptionsList = () => {
        if (Array.isArray(props.options)) return props.options;
        if (props.options && typeof props.options === 'object') return [props.options];
        return [];
    };

    const selectByValue = (value) => {
        const options = getOptionsList();
        if (options.length === 0) return;

        if (!Array.isArray(props.options) && props.options && props.options.value === value) {
            onChange(props.options);
            return;
        }

        options.forEach((op) => {
            if (op && op.value === value) {
                onChange(op);
            }
        });
    }

    const solicitarProduto = () => {
        const user = JSON.parse(localStorage.getItem(USER));

        const functions = user.contrato.agro_plan_functions;
        functions.map((f) => {
            if (f.agro_plan_function_id === 7) {
                if (f.status === 0) {
                    setModalBlock(true);
                } else {
                    setModalSolicitar(true);
                }
            }
        });
    }

    const solicitarSucesso = () => {
        store.addNotification({
            title: "Sucesso!",
            message: `Produto solicitado com sucesso!`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true
            }
        });
        setModalSolicitar(false);
    }

    const clear = () => {
        if (value.value) {
            setIsOpen(false);
            triggerOnChange({ value: '', label: '' });
        } else if (typeof value === 'string') {
            setValue('');
            setIsOpen(false);
            triggerOnChange({ value: '', label: '' });
            setSelectOptions(props.options)
        }
    }

    const clickArrow = () => {

        if (props.disabled === !true) {
            if (isOpen === true) {
                setIsOpen(false);
            } else {
                setIsOpen(true);
                ref.current.focus();
            }
        } else if (!props.disabled) {
            if (isOpen === true) {
                setIsOpen(false);
            } else {
                setIsOpen(true);
                ref.current.focus();
            }
        } else {

        }
    }

    const onFocusInput = () => {
        if (props.disabled === false || !props.disabled) {
            if (!isOpen) {
                // getElementById pode não achar o elemento (id duplicado entre 2 telas
                // montadas ao mesmo tempo, ex: form embutido num modal sobre a tela de
                // fundo) - mesma proteção já usada em input_v2.js.
                const el = props.id ? document.getElementById(props.id) : null;
                if (el && el.select) el.select();
            }
            setIsOpen(true);
        }
    }

    const searchGoogleImages = (search) => {
        window.open(`https://www.google.com/search?q=${search}&sxsrf=ALiCzsY0y3LwsxgN0oeayW3_AJMzZFXcng:1657226469380&source=lnms&tbm=isch&sa=X&ved=2ahUKEwjV5ZPY0ef4AhWYpZUCHYKmDtAQ_AUoAXoECAIQAw&biw=1536&bih=792&dpr=1.25`, '_blank');
    }


    useEffect(() => {
        if (props.options) {
            setSelectOptions(props.options);

            if (props.options.length === 0) {
                setValue('');
            }
        }

        if (props.value != 0 && props.value != undefined && props.value != '') {
            if (props.selectUniqueOption === true) {
                selectByValue(props.value);
            }
        }

        if (props.value || props.value === 0) {
            selectByValue(props.value);
        } else if (props.value === '') {
            setValue('');
        }
    }, [props.options, props.value, props.selectUniqueOption]);

    useEffect(() => {
        if (selectOptions.length > 0) {
            if (selectOptions.length == 1) {
                if (value) {
                    if (selectOptions[0]) {
                        if (value.value != selectOptions[0].value) {
                            if (props.selectUniqueOption === true) {
                                onChange(selectOptions[0]);
                            }
                        }
                    }
                } else {
                    if (selectOptions[0]) {
                        if (selectOptions[0].value) {
                            if (props.selectUniqueOption === true) {
                                onChange(selectOptions[0]);
                            }
                        }
                    }
                }
            }
            setSolicitaP(false)
        } else {
            setSolicitaP(true)
        }

        if (selectOptions.value) {
            if (selectOptions[0] === undefined) {
                setSelectOptions([selectOptions]);
            }
        }
    }, [selectOptions]);

    useEffect(() => {
        if (props.yesNo === true) {
            props.onChangeYesNo(yesNoValue);
        }
    }, [yesNoValue]);

    useEffect(() => {
        setYesNoValue(props.yesNoValue);
    }, [props.yesNoValue])

    useEffect(() => {
        if (props.isOpen) {
            props.isOpen(isOpen);
        }

        if (isOpen) {
            setLimit(20);
        }
    }, [isOpen])

    useEffect(() => {

        if (isclose) {
            if (value && selectOptions.length === 0) {
                setValue('');
                clear();
            } else {
                if (value) {
                    if (selectOptions.length > 1) {
                        if (value.label) {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value.label) {
                                    save = so;
                                }
                            });

                            if (save !== '') {
                                onChange(save);
                            } else {
                                setValue('');
                                clear();
                            }
                        } else {
                            setValue('');
                            clear();
                        }
                    } else {
                        if (value.label) {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value.label) {
                                    save = so;
                                }
                            });

                            if (save !== '') {
                                onChange(save);
                            } else {
                                setValue('');
                                clear();
                            }
                        } else {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value) {
                                    save = so;
                                }
                            });

                            if (save !== '') {
                                onChange(save);
                            } else {
                                setValue('');
                                clear();
                            }
                        }
                    }
                } else {
                    if (props.estado && props.estado.value === "SP") {
                        if (selectOptions.length === 1) {
                            return;
                        }
                    } else {
                        if (selectOptions.length === 1) {
                            onChange(selectOptions[0]);
                        }
                    }
                }
            }

            setTimeout(() => {
                setIsOpen(false);
                setisclose(false)
            }, 300);
        }
    }, [isclose])

    useEffect(() => {
        if (addOptions) {
            let sum = limit + 20;

            if (sum <= selectOptions.length) {
                if (limit !== sum) {
                    setLimit(sum);
                }
            } else {
                if (limit !== selectOptions.length) {
                    setLimit(selectOptions.length);
                }
            }
            setTimeout(() => {
                setAddOptions(false);
            }, 500);
        }
    }, [addOptions]);

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                setAddOptions(true);
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        }
    );

    const element = document.querySelector('#loading-options')
    if (element) {
        observer.observe(element);
    }

    return (
        <SelectContainerV2
            isOpen={isOpen}
            erro={props.erro}
            isModal={props.isModal}
            disabled={props.disabled}
            loading={props.loading}
            yesNo={props.yesNo}
            marginBottom={props.marginBottom}
            addNew={props.buttonAddNew}
            buttonDelete={props.buttonDelete}
            minHeight={props.minHeight}
            height={props.height}
            multilineOptions={props.multilineOptions}
        >
            <div className="container-Input" style={{
                marginTop: props.buttonAddNew ? '0' : '0px',
                position: 'relative',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                {props.loading === true ? ("") : (
                    props.buttonDelete && (
                    <div 
                        className="clear-button" 
                        style={{
                            position: 'absolute',
                            right: '50px',
                            top: '48%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 2,
                        }}
                        onClick={() => {
                            setValue(''); 
                            triggerOnChange('');
                        }}
                    >
                        <img 
                            src={DeleteIcon} 
                            alt="Clear"
                            style={{
                                width: '12px',
                                height: '12px',
                            }}
                        />
                    </div>
                )
                )}
  
                
                <div className='select'>
                    <Label
                        erro={props.erro}
                        isFocus={isOpen}
                        existValue={value == '' ? false : true}
                        onClick={() => onFocusInput()}
                        isSearch={props.isSearch}
                        isDisabled={props.disabled}
                        buttonAddNew={props.buttonAddNew}
                        isYesNo={props.yesNo}
                        isModal={props.isModal}
                        labelWithAsterisk={props.labelWithAsterisk}
                    >
                        {props.labelWithAsterisk && 
                            <b>*</b>}
                            
                        {props.label || props.placeholder}
                    </Label>


                    {props.yesNo === true ? (
                        <>

                            {props.responsive ? (
                                <YesNoContainerMobile responsive={props.responsive} disabled={props.disabled} loading={props.loading}> 
                                    <TaglineM color={theme.colors.black.Preto}>
                                        {props.messageYesNo}
                                    </TaglineM>

                                    <Interruptor value={yesNoValue} onChange={(e) => setYesNoValue(e)} /> 
                                </YesNoContainerMobile>

                            ) : (
                                <YesNoContainer
                                    yesNoLeft={props.yesNoLeft}
                                    showDisabled={props.showDisabledYesNo}
                                    disabled={props.disabled}
                                    loading={props.loading}
                                // responsive={props.responsive}
                                >
                                    <TaglineM color={theme.colors.black.Preto}>
                                        {props.messageYesNo}
                                    </TaglineM>

                                    <Interruptor
                                        value={yesNoValue}
                                        onChange={(e) => setYesNoValue(e)}
                                    />
                                </YesNoContainer>
                            )}
                        </>
                    ) : (null)}

                    {props.yesNo === true ? (
                        <YesNoContainerMobile disabled={props.disabled} loading={props.loading}>
                            <TaglineM color={theme.colors.black.Preto}>
                                {props.messageYesNo}
                            </TaglineM>
                             
                            <Interruptor value={yesNoValue} onChange={(e) => setYesNoValue(e)} /> 
                        </YesNoContainerMobile>
                    ) : (null)}

                    <input
                        ref={ref}
                        {...props}
                        value={value.label || value || ''}
                        autocomplete='off'
                        style={{
                            width: '100%',
                            height: '50px',
                            padding: '13px 65px 12px 25px',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            borderBottomLeftRadius: isOpen ? '0px' : '8px',
                            borderBottomRightRadius: isOpen ? '0px' : '8px',
                            border: props.erro ? `solid 1px ${theme.colors.red.Vermelho_erro}` : props.isSearch ? 'solid 1px #bac1cf' : props.disabled ? 'solid 1px #cfd5df' : 'solid 1px #bac1cf',
                            backgroundColor: props.isSearch ? `${theme.colors.white.Branco}` : `${theme.colors.white.Branco}`,
                            fontFamily: 'Lato',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            fontStretch: 'normal',
                            fontStyle: 'normal',
                            lineHeight: 'normal',
                            letterSpacing: 'normal',
                            color: props.erro ? `${theme.colors.red.Vermelho_erro}` : props.disabled ? '#cfd5df' : '#303848',
                            transition: 'all 0.15s ease-in',
                            position: 'relative',
                        }}
                        onChange={(e) => changeInput(e)}
                        onBlur={(e) => close(e.target)}
                        onFocus={() => onFocusInput()}
                    ></input>
                </div>

                <div className='addnew'>
                    {props.buttonAddNew === true ? (
                        <ButtonAddNew isTotvs={props.isTotvs} responsive={props.responsive} isModal={props.isModal} disabled={props.isTotvs} onClick={() => props.isTotvs ? null : props.onClickAddNew()} />
                    ) : (null)}
                </div>
            </div>

            {props.loading === true ? (
                <>
                    <Loading
                        addNew={props.buttonAddNew}
                    />
                </>
            ) : (
                <>
                    {props.disabled === true ? (null) : (
                        <>
                            <Arrow
                                yesNo={props.yesNo}
                                erro={props.erro}
                                isOpen={isOpen}
                                addNew={props.buttonAddNew}
                                isClearable={props.isClearable}
                                disabled={props.disabled}
                                onClick={() => clickArrow()}
                                marginLeft={props.marginLeft}
                            >
                                <img
                                    className="arrow-select"
                                    src={ArrowDown}
                                    alt='arrow'
                                    onClick={() => clickArrow()}
                                />
                            </Arrow>

                            {
                                props.solicitar === true ? (
                                    <>
                                        {
                                            solicitaP === true ? (
                                                <Plus>
                                                    <p id="msg">Solicitar produto(s)</p>
                                                    <img
                                                        className="add-select"
                                                        src={DeleteIcon}
                                                        alt='add'
                                                        onClick={() => solicitarProduto()}
                                                        width='12px'
                                                    />
                                                </Plus>
                                            ) : (
                                                <>
                                                    {
                                                        props.isClearable ? (
                                                            <Clearabled erro={props.erro} isOpen={isOpen} disabled={props.disabled}>
                                                                <img
                                                                    className="delete-select"
                                                                    src={DeleteIcon}
                                                                    alt='delete'
                                                                    onClick={() => clear()}
                                                                    width='12px'
                                                                />
                                                            </Clearabled>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                ) : (
                                    <>
                                        {
                                            props.isClearable ? (
                                                <Clearabled erro={props.erro} isOpen={isOpen} disabled={props.disabled}>
                                                    <img
                                                        className="delete-select"
                                                        src={DeleteIcon}
                                                        alt='delete'
                                                        onClick={() => clear()}
                                                        width='12px'
                                                    />
                                                </Clearabled>
                                            ) : (
                                                null
                                            )
                                        }
                                    </>
                                )
                            }
                        </>
                    )}
                </>
            )}

            {props.help === true ? (
                <div className="help-buttom" onClick={() => props.helpClick()}>
                    <IconHelp
                        fill='#5DA8FD'
                        cursor='pointer'
                    />
                </div>
            ) : (null)}


            {isOpen && (
                <Options isOpen={isOpen} isSearch={props.isSearch} isClearable={props.isClearable} erro={props.erro} marginBottom={props.marginBottom}>
                    {selectOptions.length > 0 ? (
                        selectOptions.map((op, i) => (
                            op && i < limit && (
                                <Option
                                    isSearch={props.isSearch}
                                    key={`op_${op.value}_${i}`}
                                    erro={props.erro}
                                    onClick={() => onChange(op)}
                                    multilineOptions={props.multilineOptions}
                                    hasDescription={!!op.description}
                                >
                                    {op.description ? (
                                        <OptionLabelBlock>
                                            {op.label}
                                            <OptionDescription>{op.description}</OptionDescription>
                                        </OptionLabelBlock>
                                    ) : (
                                        renderOptionLabel(op)
                                    )}
                                    {op.label && props.searchPhoto ? (
                                        <div
                                            className="button-foto"
                                            style={{
                                                width: '90px',
                                                minWidth: '90px',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-evenly',
                                                alignItems: 'center',
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <Button
                                                width='90px'
                                                value='Detalhes'
                                                outline={true}
                                                disabled={false}
                                                onClick={() => props.onDossie ? props.onDossie(op) : searchGoogleImages(op.label)}
                                                loading={false}
                                            />
                                        </div>
                                    ) : null}

                                    {i === (limit - 3) && (
                                        <div id='loading-options'></div>
                                    )}
                                </Option>
                            )
                        ))
                    ) : (
                        <NoOptions>
                            Não há resultados
                        </NoOptions>
                    )}

                </Options>
            )}

            {props.erro && props.messageErro ? (
                <Legenda>{props.messageErro}</Legenda>
            ) : (<>
                {props.legenda && (
                    <Legenda>{props.legenda}</Legenda>
                )}
            </>)}

            <ModalAlert
                show={showModalSolicitar}
                onHide={() => setModalSolicitar(false)}
                title="Solicitar Produto"
                size='lg'
            >
                <p style={{
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '22px',
                    fontWeight: 'bold'
                }}>Solicitar um ou mais produto(s)</p>

                <Solicitar isModal={true} closeModalS={() => solicitarSucesso()} />
            </ModalAlert>

            <ModalAlert
                show={showModalBlock}
                onHide={() => setModalBlock(false)}
                title="Solicitar Produto"
            >
                <p style={{
                    fontFamily: 'Lato',
                    fontSize: '22px',
                    fontWeight: 'bold',
                    fontStretch: 'normal',
                    width: '100%',
                    textAlign: 'center',
                    alignSelf: 'center'
                }}>
                    Essa função não está liberada para o seu plano
                </p>

                <div
                    style={{
                        color: '#303848',
                        fontFamily: 'Lato',
                        fontSize: '16px',
                        fontWeight: 'normal',
                        width: '100%',
                        textAlign: 'center',
                        alignSelf: 'center'
                    }}
                >
                    <p style={{
                        color: '#303848',
                        fontFamily: 'Lato',
                        fontSize: '16px',
                        fontWeight: 'normal',
                        width: '100%',
                        textAlign: 'center',
                        alignSelf: 'center'
                    }}>
                        Faça um upgrade para desbloquear esse recurso
                    </p>

                    <div
                        style={{
                            width: '100%',
                            maxWidth: '350px',
                            margin: 'auto',
                            marginTop: '20px',
                            alignSelf: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Button
                            width='296px'
                            height='50px'
                            value='VER PLANOS'
                            outline={false}
                            disabled={false}
                            onClick={() => {
                                setModalBlock(false);
                                window.location = '/planos';
                            }}
                            loading={false}
                        />
                    </div>
                </div>
            </ModalAlert>
        </SelectContainerV2>
    );
}

export default SelectV2;
